// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

// ** Axios Imports
// import axios from 'axios'
import useJwt from '@src/auth/jwt/useJwt'

export const getAllBatches = createAsyncThunk('getAllBatches/GET', async () => {
  const response = await useJwt.getAllBatches()
  return response.data
})

// export const getAllData = createAsyncThunk('appUsers/getAllData', async () => {
//   const response = await axios.get('/api/lots/list/all-lots')
//   return response.data
// })

// export const getData = createAsyncThunk('appUsers/getData', async params => {
//   const response = await axios.get('/api/users/list/data', params)
//   return {
//     params,
//     data: response.data.users,
//     totalPages: response.data.total
//   }
// })

export const getBatchChildById = createAsyncThunk('batchById/get', async (id) => {
  const response = await useJwt.getBatchChildById(id)
  return response.data
})

export const editBatchByID = createAsyncThunk('editBatchByID/put', async (data, {dispatch}) => {
  const response = await useJwt.editBatchByID(data).finally(() => dispatch())
  return response.data
})

// export const getUser = createAsyncThunk('appUsers/getUser', async id => {
//   const response = await axios.get('/api/users/user', { id })
//   return response.data.user
// })

// export const addUser = createAsyncThunk('appUsers/addUser', async (user, { dispatch, getState }) => {
//   await axios.post('/apps/users/add-user', user)
//   await dispatch(getData(getState().users.params))
//   await dispatch(getAllData())
//   return user
// })

// export const deleteUser = createAsyncThunk('appUsers/deleteUser', async (id, { dispatch, getState }) => {
//   await axios.delete('/apps/users/delete', { id })
//   await dispatch(getData(getState().users.params))
//   await dispatch(getAllData())
//   return id
// })

export const uploadExcel = createAsyncThunk('uploadExcel/POST', async (params) => {
  // console.log('params', params)
  try {
    const response = await useJwt.uploadExcel(params)
    return response.data
  } catch (error) {
    // Manejar la estructura específica del backend para errores de validación
    const errorData = error?.response?.data;
    return {
        isError: true,
        errors: errorData?.message || errorData?.error || 'Error desconocido al procesar el archivo',
        errorDetails: {
            status: errorData?.status,
            error: errorData?.error,
            message: errorData?.message,
            timestamp: errorData?.timestamp,
            path: errorData?.path,
        },
        response: error.response,
    };
  }
})

export const appLotSlice = createSlice({
  name: 'lotsSLice',
  initialState: {
    data: [],
    total: 1,
    params: {},
    allData: [],
    selectedUser: null,
    editBatch: [],
    hasDataEdit: false

  },
  reducers: {
    isDataLoad: (state, action) => {
      state.hasDataEdit = action.payload
    }
  },
  extraReducers: builder => {
    builder
    .addCase(getAllBatches.fulfilled, (state, action) => {
      state.data = action.payload
    })
      // .addCase(getAllData.fulfilled, (state, action) => {
      //   state.allData = action.payload
      // })
      // .addCase(getData.fulfilled, (state, action) => {
      //   state.data = action.payload.data
      //   state.params = action.payload.params
      //   state.total = action.payload.totalPages
      // })
      // .addCase(getUser.fulfilled, (state, action) => {
      //   state.selectedUser = action.payload
      // })
      .addCase(getBatchChildById.fulfilled, (state, action) => {
        state.editBatch = action.payload
        state.hasDataEdit = true
      })
      // .addCase(getBatchChildById.rejected, (state) => {
      //   state.hasDataEdit = false
      // })
  }
})

export const { isDataLoad } = appLotSlice.actions

export default appLotSlice.reducer
